import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, resolveDirective as _resolveDirective, withDirectives as _withDirectives, toHandlers as _toHandlers, mergeProps as _mergeProps, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "flex flex-col w-[full] h-[90vh] max-h-[60vh] overflow-y-auto bg-gray-50 rounded-lg p-2 mt-4" }
const _hoisted_2 = { class: "cursor-pointer my-2 flex items-center justify-between" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", { class: "font-bold" }, "Gestão dos vínculos da Política", -1)
const _hoisted_4 = {
  key: 1,
  class: "flex gap-2 text-xs text-gray-500 font-bold"
}
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "flex w-full font-bold text-sm" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "w-[7%] text-start" }, "#ID"),
  /*#__PURE__*/_createElementVNode("div", { class: "w-[13%] text-start" }, "Política"),
  /*#__PURE__*/_createElementVNode("div", { class: "w-[19%] text-start" }, "Início da Vigência"),
  /*#__PURE__*/_createElementVNode("div", { class: "w-[20%] text-start" }, "Final da Vigência"),
  /*#__PURE__*/_createElementVNode("div", { class: "w-[20%] text-start" }, "Data do Vínculo"),
  /*#__PURE__*/_createElementVNode("div", { class: "w-[10%] text-start" }, "Responsável"),
  /*#__PURE__*/_createElementVNode("div", { class: "w-[5%]" })
], -1)
const _hoisted_6 = { class: "col-span-1" }
const _hoisted_7 = { class: "col-span-2" }
const _hoisted_8 = { class: "col-span-2" }
const _hoisted_9 = { class: "col-span-2" }
const _hoisted_10 = { class: "col-span-2" }
const _hoisted_11 = { class: "col-span-2" }
const _hoisted_12 = { class: "col-span-1 flex items-center justify-center" }
const _hoisted_13 = ["onClick", "disabled"]
const _hoisted_14 = { class: "my-3 flex justify-between items-center gap-4" }
const _hoisted_15 = { class: "flex gap-2 items-center" }
const _hoisted_16 = { class: "w-[250px]" }

import { ref, PropType, computed, watch, nextTick } from 'vue'
import { storeToRefs } from 'pinia'
import { EModals, useModalStore } from '@/pinia-store/useModalStore'
import ModalVue from '@/components/designSystem/modals/Modal.vue'
import DsPaymentPolicySelect from '@/components/designSystem/Select/DsPaymentPolicySelect.vue'

import {
  mdiCheckCircleOutline,
  mdiCloseCircleOutline,
  mdiDeleteOutline,
  mdiCalendar
} from '@mdi/js'
import EditPencilIcon from '@/assets/icons/edit-pencil.vue'
import FilledButton from '@/components/designSystem/Buttons/FilledButton/index.vue'
import { DatePicker } from 'v-calendar'
import GenericInput from '@/components/designSystem/Inputs/GenericInput.vue'
import PolicyService from '@/Network/Services/DsPolicyService'
import { useToast } from 'vue-toastification'
import { useErrorToast } from '@/composables/useErrorToast'

type TableLinkPolicyItem = {
  policyId?: string
  policyName?: string
  startDate?: string
  endDate?: string
  linkedAt?: string
  linkedBy?: string
}


export default /*#__PURE__*/_defineComponent({
  __name: 'policies',
  props: {
  modelValue: {
    type: Array as PropType<TableLinkPolicyItem[]>,
    default: () => [] as TableLinkPolicyItem[]
  }
},
  emits: ['update:modelValue', 'saveItems'],
  setup(__props, { emit }) {

const props = __props;




const modalName = EModals.POLICIES_MODAL
const toast = useToast()
const { notifyError } = useErrorToast()

const modalStore = useModalStore()
const modals = storeToRefs(modalStore).modals

const DsPolicyService = new PolicyService()
const isLoading = ref(false)
const draftSaved = ref(false)
const toggleEdit = ref<boolean>(false)
const selectedPolicy = ref<any>(null)

const canSaveFinalVersion = computed(() => {
  return !toggleEdit.value && draftSaved.value && hasChangesToSave.value && !isLoading.value
})

const hasChangesToSave = computed(() => {
  const formattedCurrent = draftItems.value.map((item) => ({
    dsPolicyId: Number(item.policyId),
    policyName: item.policyName,
    startDate: item.startDate,
    endDate: item.endDate,
    linkedAt: item.linkedAt,
    linkedBy: item.linkedBy
  }))

  const formattedSaved = lastSavedPolicies.value.map((item) => ({
    dsPolicyId: Number(item.dsPolicyId),
    policyName: item.policyName,
    startDate: item.startDate,
    endDate: item.endDate,
    linkedAt: item.linkedAt,
    linkedBy: item.linkedBy
  }))

  return JSON.stringify(formattedCurrent) !== JSON.stringify(formattedSaved)
})

const colorHex = computed(() => (toggleEdit.value ? '#2F7F91' : '#D3D3D3'))

watch(
  () => modals.value[modalName],
  async (val) => {
    if (val) await fetchLinkedPolicies()
  }
)

watch(selectedPolicy, async (policy) => {
  if (!policy) return

  draftItems.value.push({
    policyId: policy.id,
    policyName: policy.name,
    startDate: '',
    endDate: '',
    linkedAt: new Date().toISOString().split('T')[0],
    linkedBy: policy.createdBy ?? ''
  })

  await nextTick()
  selectedPolicy.value = null
})
const draftItems = ref<Array<TableLinkPolicyItem>>([])

const lastSavedPolicies = ref<Array<any>>([])

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const initDraft = () => {
  draftItems.value = props.modelValue.map((item) => ({
    policyId: item.policyId ?? '',
    policyName: item.policyName ?? '',
    startDate: item.startDate ?? '',
    endDate: item.endDate ?? '',
    linkedAt: item.linkedAt ?? '',
    linkedBy: item.linkedBy ?? ''
  }))

  lastSavedPolicies.value = draftItems.value.map((item) => ({
    dsPolicyId: Number(item.policyId),
    policyName: item.policyName,
    startDate: item.startDate,
    endDate: item.endDate,
    linkedAt: item.linkedAt,
    linkedBy: item.linkedBy
  }))
}

const removeItem = (index: number) => {
  draftItems.value.splice(index, 1)
}

const closeEditMode = () => {
  toggleEdit.value = false
  draftSaved.value = false
  fetchLinkedPolicies()
}

const saveEditMode = () => {
  if (!hasChangesToSave.value) {
    toast.warning('Nenhuma alteração foi feita.')
    return
  }

  emit('update:modelValue', draftItems.value)
  emit('saveItems', draftItems.value)

  draftSaved.value = true
  toggleEdit.value = false
}

const handleToggleModal = () => {
  modalStore.toggleModal(modalName)
}

const fetchLinkedPolicies = async () => {
  try {
    isLoading.value = true
    const resourceId = modalStore.metadata?.resourceId as number
    let response

    switch (modalStore.metadata?.resourceType) {
      case 'company':
        response = await DsPolicyService.listCompanyDsPolicyLinks(resourceId)
        break
      case 'health_unit':
        response = await DsPolicyService.listHealthUnitDsPolicyLinks(resourceId)
        break
      case 'schedule':
        response = await DsPolicyService.listScheduleDsPolicyLinks(resourceId)
        break
      case 'position':
        response = await DsPolicyService.listPositionDsPolicyLinks(resourceId)
        break
    }

    if (!response || !response.data) {
      toast.error('Não foi possível carregar os dados da política.')
      return
    }

    draftItems.value = response.data.map((item: any) => ({
      policyId: item.dsPolicy?.id,
      policyName: item.dsPolicy?.name,
      startDate: item.startDate,
      endDate: item.endDate,
      linkedAt: item.createdAt,
      linkedBy: item.linkedBy?.name ?? ''
    }))

    lastSavedPolicies.value = draftItems.value.map((item) => ({
      dsPolicyId: Number(item.policyId),
      startDate: item.startDate,
      endDate: item.endDate
    }))
  } catch (e) {
    notifyError(e, 'Não foi possível carregar os vínculos da política.')
  } finally {
    isLoading.value = false
  }
}
const formatDate = (date: string | Date): string => {
  if (!date) return ''
  const d = new Date(date)
  d.setUTCHours(0, 0, 0, 0)
  return d.toISOString()
}

const saveAllItems = async () => {
  // Validação local FORA do try: preenchimento incompleto não pode passar pelo
  // funil de erro de API (`notifyError`), que exibiria a mensagem de falha ao
  // salvar e sugeriria um problema de rede/backend em vez do campo em branco.
  const hasMissingDates = draftItems.value.some((item) => !item.startDate || !item.endDate)
  if (hasMissingDates) {
    toast.error('Data de início ou fim ausente em uma das políticas.')
    return
  }

  try {
    const formattedItems = draftItems.value.map((item) => ({
      dsPolicyId: Number(item.policyId),
      startDate: formatDate(item.startDate ?? ''),
      endDate: formatDate(item.endDate ?? '')
    }))

    const hasEmptyFields = formattedItems.some((i) => !i.dsPolicyId || !i.startDate || !i.endDate)
    if (hasEmptyFields) {
      toast.error('Todos os campos são obrigatórios.')
      return
    }
    const invalidDateIndex = formattedItems.findIndex((item) => {
      const start = new Date(item.startDate)
      const end = new Date(item.endDate)
      return start > end
    })

    if (invalidDateIndex !== -1) {
      toast.error('A data de início não pode ser maior que a data final')
      return
    }

    const hasChanges =
      JSON.stringify(formattedItems) !==
      JSON.stringify(
        lastSavedPolicies.value.map((item) => ({
          dsPolicyId: Number(item.dsPolicyId),
          startDate: item.startDate,
          endDate: item.endDate
        }))
      )

    if (!hasChanges) {
      toast.warning('Nenhuma alteração foi feita.')
      return
    }

    isLoading.value = true
    const resourceId = modalStore.metadata?.resourceId as number

    switch (modalStore.metadata?.resourceType) {
      case 'company':
        await DsPolicyService.updateCompanyDsPolicyLinks(resourceId, {
          policies: formattedItems
        })
        break
      case 'health_unit':
        await DsPolicyService.updateHealthUnitDsPolicyLinks(resourceId, {
          policies: formattedItems
        })
        break
      case 'schedule':
        await DsPolicyService.updateScheduleDsPolicyLinks(resourceId, {
          policies: formattedItems
        })
        break
      case 'position':
        await DsPolicyService.updatePositionDsPolicyLinks(resourceId, {
          policies: formattedItems
        })
        break
    }

    toast.success('Vínculos atualizados com sucesso!')
    modalStore.toggleModal(modalName)
    toggleEdit.value = false
  } catch (e) {
    // Antes: extrator concorrente (`e?.response?.data?.message`) que ficava MUDO
    // quando o erro não tinha esse shape. `notifyError` sempre notifica.
    console.error('Erro ao salvar os vínculos da política:', e)
    notifyError(e, 'Não foi possível salvar os vínculos da política.')
  } finally {
    isLoading.value = false
  }
}

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _directive_maska = _resolveDirective("maska")!

  return (_openBlock(), _createBlock(ModalVue, {
    onClose: handleToggleModal,
    modalActive: _unref(modals)[_unref(modalName)]
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _hoisted_3,
          (!toggleEdit.value)
            ? (_openBlock(), _createBlock(EditPencilIcon, {
                key: 0,
                onClick: _cache[0] || (_cache[0] = ($event: any) => (toggleEdit.value = !toggleEdit.value)),
                color: "#2F7F91"
              }))
            : _createCommentVNode("", true),
          (toggleEdit.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                _createElementVNode("span", { onClick: saveEditMode }, [
                  _createVNode(_component_v_icon, {
                    icon: _unref(mdiCheckCircleOutline),
                    color: "#22bb33",
                    class: "cursor-pointer"
                  }, null, 8, ["icon"]),
                  _createTextVNode(" Salvar Rascunho ")
                ]),
                _createElementVNode("span", { onClick: closeEditMode }, [
                  _createVNode(_component_v_icon, {
                    icon: _unref(mdiCloseCircleOutline),
                    color: "#bb2124",
                    class: "cursor-pointer"
                  }, null, 8, ["icon"]),
                  _createTextVNode(" Descartar Rascunho ")
                ])
              ]))
            : _createCommentVNode("", true)
        ]),
        _hoisted_5,
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(draftItems.value, (item, index) => {
          return (_openBlock(), _createElementBlock("div", {
            key: index,
            class: "grid grid-cols-12 gap-2 w-full items-start mt-3"
          }, [
            _createElementVNode("div", _hoisted_6, [
              _withDirectives(_createVNode(GenericInput, {
                disabled: true,
                modelValue: item.policyId,
                "onUpdate:modelValue": ($event: any) => ((item.policyId) = $event),
                name: "linkId",
                density: "comfortable",
                label: "ID",
                variant: "outlined",
                class: "w-full"
              }, null, 8, ["modelValue", "onUpdate:modelValue"]), [
                [_directive_maska, '##########']
              ])
            ]),
            _createElementVNode("div", _hoisted_7, [
              _createVNode(GenericInput, {
                disabled: true,
                modelValue: item.policyName,
                "onUpdate:modelValue": ($event: any) => ((item.policyName) = $event),
                name: "politica",
                density: "comfortable",
                label: "Política",
                variant: "outlined",
                class: "w-full"
              }, null, 8, ["modelValue", "onUpdate:modelValue"])
            ]),
            _createElementVNode("div", _hoisted_8, [
              _createVNode(_unref(DatePicker), {
                modelValue: item.startDate,
                "onUpdate:modelValue": ($event: any) => ((item.startDate) = $event),
                locale: "pt-BR",
                masks: { modelValue: 'YYYY-MM-DD', input: 'DD/MM/YYYY' },
                "is-required": ""
              }, {
                default: _withCtx(({ inputValue, inputEvents }) => [
                  _createVNode(_component_v_text_field, _mergeProps({
                    label: "Início",
                    "model-value": inputValue
                  }, _toHandlers(inputEvents), {
                    class: "w-full",
                    disabled: !toggleEdit.value,
                    color: "primary20",
                    variant: "outlined",
                    density: "comfortable",
                    "prepend-inner-icon": _unref(mdiCalendar)
                  }), null, 16, ["model-value", "disabled", "prepend-inner-icon"])
                ]),
                _: 2
              }, 1032, ["modelValue", "onUpdate:modelValue"])
            ]),
            _createElementVNode("div", _hoisted_9, [
              _createVNode(_unref(DatePicker), {
                modelValue: item.endDate,
                "onUpdate:modelValue": ($event: any) => ((item.endDate) = $event),
                locale: "pt-BR",
                masks: { modelValue: 'YYYY-MM-DD', input: 'DD/MM/YYYY' },
                "is-required": ""
              }, {
                default: _withCtx(({ inputValue, inputEvents }) => [
                  _createVNode(_component_v_text_field, _mergeProps({
                    label: "Final",
                    "model-value": inputValue
                  }, _toHandlers(inputEvents), {
                    class: "w-full",
                    disabled: !toggleEdit.value,
                    color: "primary20",
                    variant: "outlined",
                    density: "comfortable",
                    "prepend-inner-icon": _unref(mdiCalendar)
                  }), null, 16, ["model-value", "disabled", "prepend-inner-icon"])
                ]),
                _: 2
              }, 1032, ["modelValue", "onUpdate:modelValue"])
            ]),
            _createElementVNode("div", _hoisted_10, [
              _createVNode(_unref(DatePicker), {
                modelValue: item.linkedAt,
                "onUpdate:modelValue": ($event: any) => ((item.linkedAt) = $event),
                locale: "pt-BR",
                masks: { modelValue: 'YYYY-MM-DD', input: 'DD/MM/YYYY' },
                "is-required": ""
              }, {
                default: _withCtx(({ inputValue, inputEvents }) => [
                  _createVNode(_component_v_text_field, _mergeProps({
                    label: "Data",
                    "model-value": inputValue
                  }, _toHandlers(inputEvents), {
                    class: "w-full",
                    disabled: true,
                    color: "primary20",
                    variant: "outlined",
                    density: "comfortable",
                    "prepend-inner-icon": _unref(mdiCalendar)
                  }), null, 16, ["model-value", "prepend-inner-icon"])
                ]),
                _: 2
              }, 1032, ["modelValue", "onUpdate:modelValue"])
            ]),
            _createElementVNode("div", _hoisted_11, [
              _createVNode(GenericInput, {
                disabled: true,
                modelValue: item.linkedBy,
                "onUpdate:modelValue": ($event: any) => ((item.linkedBy) = $event),
                name: "responsável",
                density: "comfortable",
                label: "Responsável",
                variant: "outlined",
                class: "w-full"
              }, null, 8, ["modelValue", "onUpdate:modelValue"])
            ]),
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("button", {
                onClick: ($event: any) => (removeItem(index)),
                disabled: !toggleEdit.value
              }, [
                _createVNode(_component_v_icon, {
                  icon: _unref(mdiDeleteOutline),
                  color: colorHex.value,
                  size: "24"
                }, null, 8, ["icon", "color"])
              ], 8, _hoisted_13)
            ])
          ]))
        }), 128)),
        _createElementVNode("div", _hoisted_14, [
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("div", _hoisted_16, [
              _createVNode(DsPaymentPolicySelect, {
                modelValue: selectedPolicy.value,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((selectedPolicy).value = $event))
              }, null, 8, ["modelValue"])
            ])
          ]),
          _createElementVNode("div", null, [
            _createVNode(FilledButton, {
              onClick: saveAllItems,
              disabled: !canSaveFinalVersion.value,
              width: "100px",
              height: "40px",
              text: "Salvar",
              loading: isLoading.value
            }, null, 8, ["disabled", "loading"])
          ])
        ])
      ])
    ]),
    _: 1
  }, 8, ["modalActive"]))
}
}

})